import service from "./service"

const confirmPaperProcess = async (data) => {
    return service(data)
}

export default confirmPaperProcess
